var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "b-loading",
          {
            attrs: { "is-full-page": true, "can-cancel": false },
            model: {
              value: _vm.isLoadingDocument,
              callback: function ($$v) {
                _vm.isLoadingDocument = $$v
              },
              expression: "isLoadingDocument",
            },
          },
          [_c("Spinner")],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _c("Header", {
          attrs: { id: "top" },
          model: {
            value: _vm.documentsUploaded,
            callback: function ($$v) {
              _vm.documentsUploaded = $$v
            },
            expression: "documentsUploaded",
          },
        }),
        _c("div", { staticClass: "internal-content" }, [
          _vm._m(0),
          _c("div", { staticClass: "general-content" }, [
            _c(
              "div",
              { attrs: { id: "document-content" } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "columns custom-columns is-flex-desktop is-vcentered",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "title has-text-centered-mobile is-3 has-text-white",
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("section-title")) + " ")]
                        ),
                        _vm.prospectInformation
                          ? _c("HighlightSimulation", {
                              attrs: {
                                "prospect-id": _vm.prospectInformation._id,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "column is-one-third is is-full-mobile" },
                      [
                        _c(
                          "div",
                          { staticClass: "card-item prospect mt-5" },
                          [
                            _vm.prospectInformation
                              ? _c("prospect-information", {
                                  attrs: {
                                    name: _vm.prospectInformation.name,
                                    "last-name":
                                      _vm.prospectInformation.lastName,
                                    email: _vm.prospectInformation.email,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
                _vm.prospectInformation
                  ? _c("timeline", {
                      key: _vm.timekey,
                      attrs: {
                        "prospect-id": _vm.prospectInformation._id,
                        "prospect-status": _vm.prospectInformation.status,
                      },
                    })
                  : _vm._e(),
                _c("div", { attrs: { id: "content" } }, [
                  !_vm.documentsUploaded &&
                  !(
                    _vm.counterUploadedDocuments(_vm.documentsList, 0) ===
                      _vm.counterDocuments(_vm.documentsList, 0) &&
                    (_vm.counterUploadedDocuments(_vm.documentsList, 1) ===
                      _vm.counterDocuments(_vm.documentsList, 1) ||
                      _vm.counterUploadedDocuments(_vm.documentsList, 2) ===
                        _vm.counterDocuments(_vm.documentsList, 2))
                  )
                    ? _c(
                        "div",
                        { staticClass: "document-notification my-5" },
                        [
                          _c(
                            "b-notification",
                            {
                              attrs: {
                                type: "is-info is-light",
                                "aria-close-label": "Close notification",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message-preapprover")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.documentsUploaded && _vm.uploadedByRole === "PROSPECT"
                    ? _c(
                        "div",
                        { staticClass: "document-notification my-5" },
                        [
                          _c(
                            "b-notification",
                            {
                              attrs: {
                                type: "is-success is-light",
                                closable: false,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "success-notification" },
                                [
                                  _c("img", {
                                    staticClass: "clock-icon",
                                    attrs: {
                                      src: require("@/ui/assets/img/clock.gif"),
                                      alt: "reloj",
                                    },
                                  }),
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "title-color title is-6 has-text-weight-light has-text-justified",
                                    },
                                    [
                                      _c("b", [_vm._v("Parabéns!")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("48hs-message1")) +
                                          " Nas próximas "
                                      ),
                                      _c("b", [_vm._v("48 horas")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("48hs-message2")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.uploadedByRole === "EXECUTIVE" &&
                  _vm.filesCompletedByEmploymentType()
                    ? _c(
                        "div",
                        { staticClass: "document-notification my-5" },
                        [
                          _c(
                            "b-notification",
                            {
                              attrs: {
                                type: "is-success is-light",
                                closable: false,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "success-notification" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "title-color title is-6 has-text-weight-light has-text-justified",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "executive-message-uploaded-documents"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "columns is-variable is-8" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "card-item document-view" }, [
                        _c(
                          "section",
                          [
                            _c(
                              "b-tabs",
                              {
                                class: { "tab-no-codebtor": !_vm.hasCodebtor },
                                attrs: {
                                  size: _vm.isSmallScreen()
                                    ? "is-smoll"
                                    : "is-medium",
                                },
                                model: {
                                  value: _vm.activeTab,
                                  callback: function ($$v) {
                                    _vm.activeTab = $$v
                                  },
                                  expression: "activeTab",
                                },
                              },
                              [
                                _c(
                                  "b-tab-item",
                                  {
                                    attrs: {
                                      label: _vm.hasCodebtor
                                        ? _vm.$t("documents-owner")
                                        : "",
                                    },
                                  },
                                  _vm._l(
                                    _vm.documentsList,
                                    function (
                                      {
                                        description: sectionName,
                                        employmentType: employmentTypeDocument,
                                        subName: sectionSubName,
                                        hasSwitch,
                                        documents,
                                      },
                                      sectionIndex
                                    ) {
                                      return _c("div", { key: sectionIndex }, [
                                        _vm.getDocumentsToShow(
                                          employmentTypeDocument
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mb-5 section-document",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    hasSwitch
                                                      ? _c(
                                                          "b-field",
                                                          [
                                                            _c(
                                                              "b-switch",
                                                              {
                                                                attrs: {
                                                                  id: "activate-section",
                                                                  size: "is-small",
                                                                  outlined: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .documentsList[
                                                                      sectionIndex
                                                                    ]
                                                                      .isSwitched,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .documentsList[
                                                                          sectionIndex
                                                                        ],
                                                                        "isSwitched",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "documentsList[sectionIndex].isSwitched",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "h3",
                                                                  {
                                                                    staticClass:
                                                                      "title is-5 has-text-primary",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .documentsList[
                                                                          sectionIndex
                                                                        ]
                                                                          .description
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "title is-5 has-text-primary",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  sectionName
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                    sectionSubName !== ""
                                                      ? _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "control document-item columns is-mobile column is-text-right is-four-fifths blackColorText",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  sectionSubName
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.documentsList[
                                                      sectionIndex
                                                    ].isSwitched
                                                      ? _c(
                                                          "div",
                                                          _vm._l(
                                                            documents,
                                                            function (
                                                              {
                                                                file,
                                                                description:
                                                                  documentName,
                                                                hasButton,
                                                                buttonText,
                                                                buttonLink,
                                                                isUploadedBy,
                                                                messageUpload,
                                                              },
                                                              documentIndex
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    sectionIndex -
                                                                    documentIndex,
                                                                  staticClass:
                                                                    "py-3",
                                                                  class:
                                                                    _vm.getClassFullColumnDocument(
                                                                      this,
                                                                      _vm
                                                                        .documentsList[
                                                                        sectionIndex
                                                                      ]
                                                                        .documents[
                                                                        documentIndex
                                                                      ]
                                                                    ),
                                                                },
                                                                [
                                                                  _vm
                                                                    .documentsList[
                                                                    sectionIndex
                                                                  ].documents[
                                                                    documentIndex
                                                                  ].label ===
                                                                  true
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "is-text-right",
                                                                              class:
                                                                                _vm.getClassDocument(
                                                                                  this,
                                                                                  _vm
                                                                                    .documentsList[
                                                                                    sectionIndex
                                                                                  ]
                                                                                    .documents[
                                                                                    documentIndex
                                                                                  ]
                                                                                ),
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    documentName
                                                                                  )
                                                                              ),
                                                                              hasButton
                                                                                ? _c(
                                                                                    "a",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mx-2",
                                                                                      attrs:
                                                                                        {
                                                                                          type: "is-primary",
                                                                                          href: buttonLink,
                                                                                          target:
                                                                                            "_blank",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "i",
                                                                                        {
                                                                                          staticClass:
                                                                                            "fa-solid fa-file",
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            buttonText
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "b-field",
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "is-block",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "is-flex is-flex-shrink-0 is-justify-content-space-between is-align-items-center is-flex-wrap-wrap input-container",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "text-container-zx",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "input-text",
                                                                                      class:
                                                                                        _vm.getClassDocument(
                                                                                          this,
                                                                                          _vm
                                                                                            .documentsList[
                                                                                            sectionIndex
                                                                                          ]
                                                                                            .documents[
                                                                                            documentIndex
                                                                                          ]
                                                                                        ),
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            documentName
                                                                                          )
                                                                                      ),
                                                                                      hasButton
                                                                                        ? _c(
                                                                                            "a",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mx-2",
                                                                                              attrs:
                                                                                                {
                                                                                                  type: "is-primary",
                                                                                                  href: buttonLink,
                                                                                                  target:
                                                                                                    "_blank",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "i",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "fa-solid fa-file",
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    buttonText
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              file
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      key:
                                                                                        sectionIndex +
                                                                                        "-docsIndex",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "document-notification",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "b-tag",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  icon: "fa-solid fa-file",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  file.name
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                      _c(
                                                                                        "h1",
                                                                                        {
                                                                                          staticClass:
                                                                                            "text-error",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                messageUpload
                                                                                              )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm
                                                                                .documentsList[
                                                                                sectionIndex
                                                                              ]
                                                                                .documents[
                                                                                documentIndex
                                                                              ]
                                                                                .paperlessButton
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "input-button",
                                                                                    },
                                                                                    [
                                                                                      _vm.loadAutomaticHoleriteToggle &&
                                                                                      !_vm.disableButtonExternalProvider
                                                                                        ? _c(
                                                                                            "b-tooltip",
                                                                                            {
                                                                                              staticClass:
                                                                                                "icon-color",
                                                                                              attrs:
                                                                                                {
                                                                                                  multilined:
                                                                                                    "",
                                                                                                  size: "is-small",
                                                                                                  label:
                                                                                                    _vm.$t(
                                                                                                      "b-tooltip-br"
                                                                                                    ),
                                                                                                  position:
                                                                                                    "is-bottom",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "i",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "fas fa-lg fa-info-circle is-success",
                                                                                                }
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm.loadAutomaticHoleriteToggle
                                                                                        ? _c(
                                                                                            "b-button",
                                                                                            {
                                                                                              staticClass:
                                                                                                "px-6 btn-pluggy",
                                                                                              class:
                                                                                                _vm.disableButtonExternalProvider
                                                                                                  ? "btn-pluggy-connected"
                                                                                                  : "is-rounded",
                                                                                              attrs:
                                                                                                {
                                                                                                  "data-cy":
                                                                                                    "button-external-provider",
                                                                                                  disabled:
                                                                                                    _vm.disableButtonExternalProvider,
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.widgetPluggy(
                                                                                                      sectionIndex,
                                                                                                      documentIndex,
                                                                                                      "prospect",
                                                                                                      {
                                                                                                        name: "Conexão bem sucedida",
                                                                                                      }
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    _vm.disableButtonExternalProvider
                                                                                                      ? "Conta conectada"
                                                                                                      : "Conectar agora"
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                : _vm._e(),
                                                                              isUploadedBy ===
                                                                              "EXECUTIVE"
                                                                                ? _c(
                                                                                    "b-tag",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          id: "label-upload",
                                                                                          type: "is-primary is-light",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Creditú"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              isUploadedBy ===
                                                                              "BROKER"
                                                                                ? _c(
                                                                                    "b-tag",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          id: "label-upload",
                                                                                          type: "is-primary is-light",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Parceiro"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "input-icon",
                                                                                  class:
                                                                                    _vm.getClassRightColumnDocument(
                                                                                      this,
                                                                                      _vm
                                                                                        .documentsList[
                                                                                        sectionIndex
                                                                                      ]
                                                                                        .documents[
                                                                                        documentIndex
                                                                                      ]
                                                                                    ),
                                                                                },
                                                                                [
                                                                                  _vm
                                                                                    .documentsList[
                                                                                    sectionIndex
                                                                                  ]
                                                                                    .documents[
                                                                                    documentIndex
                                                                                  ]
                                                                                    .label !==
                                                                                  true
                                                                                    ? _c(
                                                                                        "b-upload",
                                                                                        {
                                                                                          staticClass:
                                                                                            "document-item",
                                                                                          class:
                                                                                            _vm
                                                                                              .documentsList[
                                                                                              sectionIndex
                                                                                            ]
                                                                                              .isSwitched ===
                                                                                            false
                                                                                              ? "section-inactive"
                                                                                              : "",
                                                                                          attrs:
                                                                                            {
                                                                                              accept:
                                                                                                ".jpg, .png, .pdf",
                                                                                              disabled:
                                                                                                _vm
                                                                                                  .documentsList[
                                                                                                  sectionIndex
                                                                                                ]
                                                                                                  .isSwitched ===
                                                                                                  false ||
                                                                                                _vm
                                                                                                  .documentsList[
                                                                                                  sectionIndex
                                                                                                ]
                                                                                                  .documents[
                                                                                                  documentIndex
                                                                                                ]
                                                                                                  .uploaded ===
                                                                                                  true,
                                                                                            },
                                                                                          on: {
                                                                                            input:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.fileReader(
                                                                                                  $event,
                                                                                                  sectionIndex,
                                                                                                  documentIndex,
                                                                                                  "prospect"
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                _vm
                                                                                                  .documentsList[
                                                                                                  sectionIndex
                                                                                                ]
                                                                                                  .documents[
                                                                                                  documentIndex
                                                                                                ]
                                                                                                  .file,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    _vm
                                                                                                      .documentsList[
                                                                                                      sectionIndex
                                                                                                    ]
                                                                                                      .documents[
                                                                                                      documentIndex
                                                                                                    ],
                                                                                                    "file",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "documentsList[sectionIndex].documents[documentIndex].file",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "b-icon",
                                                                                            {
                                                                                              class:
                                                                                                _vm.getClassIconDocument(
                                                                                                  this,
                                                                                                  _vm
                                                                                                    .documentsList[
                                                                                                    sectionIndex
                                                                                                  ]
                                                                                                    .documents[
                                                                                                    documentIndex
                                                                                                  ]
                                                                                                ),
                                                                                              attrs:
                                                                                                {
                                                                                                  size: "is-medium",
                                                                                                  icon: !_vm
                                                                                                    .documentsList[
                                                                                                    sectionIndex
                                                                                                  ]
                                                                                                    .documents[
                                                                                                    documentIndex
                                                                                                  ]
                                                                                                    .file
                                                                                                    ? _vm
                                                                                                        .documentsList[
                                                                                                        sectionIndex
                                                                                                      ]
                                                                                                        .documents[
                                                                                                        documentIndex
                                                                                                      ]
                                                                                                        .uploaded
                                                                                                      ? "check"
                                                                                                      : "arrow-up-from-bracket"
                                                                                                    : "paperclip",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              [
                                                                                _vm
                                                                                  .documentsList[
                                                                                  sectionIndex
                                                                                ]
                                                                                  .documents[
                                                                                  documentIndex
                                                                                ]
                                                                                  .uploaded ===
                                                                                  true &&
                                                                                _vm.currentUser !==
                                                                                  "PROSPECT"
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "document-icons my-2",
                                                                                        attrs:
                                                                                          {
                                                                                            "data-cy":
                                                                                              "document-icons",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.getProspectDocument(
                                                                                                _vm
                                                                                                  .documentsList[
                                                                                                  sectionIndex
                                                                                                ]
                                                                                                  .documents[
                                                                                                  documentIndex
                                                                                                ]
                                                                                                  .documentId
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "fa-solid fa-file-lines",
                                                                                          }
                                                                                        ),
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                id: `icon-${sectionIndex}-${documentIndex}`,
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm.$t(
                                                                                                    "access-to-document"
                                                                                                  )
                                                                                                )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ],
                                                                            ],
                                                                            2
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                                _vm.hasCodebtor
                                  ? _c(
                                      "b-tab-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("codebtor-document"),
                                        },
                                      },
                                      _vm._l(
                                        _vm.codebtorDocumentsList,
                                        function (
                                          {
                                            description: sectionName,
                                            subName: sectionSubName,
                                            hasSwitch,
                                            documents,
                                          },
                                          sectionIndex
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: sectionIndex,
                                              staticClass:
                                                "mb-5 section-document",
                                            },
                                            [
                                              hasSwitch
                                                ? _c(
                                                    "b-field",
                                                    [
                                                      _c(
                                                        "b-switch",
                                                        {
                                                          attrs: {
                                                            id: "activate-section",
                                                            size: "is-small",
                                                            outlined: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .codebtorDocumentsList[
                                                                sectionIndex
                                                              ].isSwitched,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .codebtorDocumentsList[
                                                                  sectionIndex
                                                                ],
                                                                "isSwitched",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "codebtorDocumentsList[sectionIndex].isSwitched",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "h3",
                                                            {
                                                              staticClass:
                                                                "title is-5 has-text-primary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  sectionName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "h3",
                                                    {
                                                      staticClass:
                                                        "title is-5 has-text-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(sectionName) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                              sectionSubName !== ""
                                                ? _c(
                                                    "h3",
                                                    {
                                                      staticClass:
                                                        "control document-item columns is-mobile column is-text-right is-four-fifths blackColorText",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            sectionSubName
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.codebtorDocumentsList[
                                                sectionIndex
                                              ].isSwitched
                                                ? _c(
                                                    "div",
                                                    _vm._l(
                                                      documents,
                                                      function (
                                                        {
                                                          file,
                                                          description:
                                                            documentName,
                                                          hasButton,
                                                          buttonText,
                                                          buttonLink,
                                                          isUploadedBy,
                                                          messageUpload,
                                                        },
                                                        documentIndex
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key:
                                                              sectionIndex -
                                                              documentIndex,
                                                            staticClass: "py-3",
                                                            class:
                                                              _vm.getClassFullColumnDocument(
                                                                this,
                                                                _vm
                                                                  .codebtorDocumentsList[
                                                                  sectionIndex
                                                                ].documents[
                                                                  documentIndex
                                                                ]
                                                              ),
                                                          },
                                                          [
                                                            _vm
                                                              .codebtorDocumentsList[
                                                              sectionIndex
                                                            ].documents[
                                                              documentIndex
                                                            ].label === true
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "columns is-mobile",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "column is-text-right",
                                                                        class:
                                                                          _vm.getClassDocument(
                                                                            this,
                                                                            _vm
                                                                              .codebtorDocumentsList[
                                                                              sectionIndex
                                                                            ]
                                                                              .documents[
                                                                              documentIndex
                                                                            ]
                                                                          ),
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              documentName
                                                                            )
                                                                        ),
                                                                        hasButton
                                                                          ? _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "mx-2",
                                                                                attrs:
                                                                                  {
                                                                                    type: "is-primary",
                                                                                    href: buttonLink,
                                                                                    target:
                                                                                      "_blank",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa-solid fa-file",
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      buttonText
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c("b-field", [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "is-block",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "is-flex is-flex-shrink-0 is-justify-content-space-between is-align-items-center is-flex-wrap-wrap input-container",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "text-container-zx",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "input-text",
                                                                              class:
                                                                                _vm.getClassDocument(
                                                                                  this,
                                                                                  _vm
                                                                                    .codebtorDocumentsList[
                                                                                    sectionIndex
                                                                                  ]
                                                                                    .documents[
                                                                                    documentIndex
                                                                                  ]
                                                                                ),
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    documentName
                                                                                  )
                                                                              ),
                                                                              hasButton
                                                                                ? _c(
                                                                                    "a",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mx-2",
                                                                                      attrs:
                                                                                        {
                                                                                          type: "is-primary",
                                                                                          href: buttonLink,
                                                                                          target:
                                                                                            "_blank",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "i",
                                                                                        {
                                                                                          staticClass:
                                                                                            "fa-solid fa-file",
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            buttonText
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      file
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              key:
                                                                                sectionIndex +
                                                                                "-docsIndex",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "document-notification my-5",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "b-tag",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          icon: "fa-solid fa-file",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          file.name
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _c(
                                                                                "h1",
                                                                                {
                                                                                  staticClass:
                                                                                    "text-error",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        messageUpload
                                                                                      )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      isUploadedBy ===
                                                                      "EXECUTIVE"
                                                                        ? _c(
                                                                            "b-tag",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  id: "label-upload",
                                                                                  type: "is-primary is-light",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Creditú"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      isUploadedBy ===
                                                                      "BROKER"
                                                                        ? _c(
                                                                            "b-tag",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  id: "label-upload",
                                                                                  type: "is-primary is-light",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Parceiro"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "input-icon",
                                                                          class:
                                                                            _vm.getClassRightColumnDocument(
                                                                              this,
                                                                              _vm
                                                                                .codebtorDocumentsList[
                                                                                sectionIndex
                                                                              ]
                                                                                .documents[
                                                                                documentIndex
                                                                              ]
                                                                            ),
                                                                        },
                                                                        [
                                                                          _vm
                                                                            .codebtorDocumentsList[
                                                                            sectionIndex
                                                                          ]
                                                                            .documents[
                                                                            documentIndex
                                                                          ]
                                                                            .label !==
                                                                          true
                                                                            ? _c(
                                                                                "b-upload",
                                                                                {
                                                                                  staticClass:
                                                                                    "document-item",
                                                                                  class:
                                                                                    _vm
                                                                                      .codebtorDocumentsList[
                                                                                      sectionIndex
                                                                                    ]
                                                                                      .isSwitched ===
                                                                                    false
                                                                                      ? "section-inactive"
                                                                                      : "",
                                                                                  attrs:
                                                                                    {
                                                                                      accept:
                                                                                        ".jpg, .png, .pdf",
                                                                                      disabled:
                                                                                        _vm
                                                                                          .codebtorDocumentsList[
                                                                                          sectionIndex
                                                                                        ]
                                                                                          .isSwitched ===
                                                                                          false ||
                                                                                        _vm
                                                                                          .codebtorDocumentsList[
                                                                                          sectionIndex
                                                                                        ]
                                                                                          .documents[
                                                                                          documentIndex
                                                                                        ]
                                                                                          .uploaded ===
                                                                                          true,
                                                                                    },
                                                                                  on: {
                                                                                    input:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.fileReader(
                                                                                          $event,
                                                                                          sectionIndex,
                                                                                          documentIndex,
                                                                                          "codebtor"
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .codebtorDocumentsList[
                                                                                          sectionIndex
                                                                                        ]
                                                                                          .documents[
                                                                                          documentIndex
                                                                                        ]
                                                                                          .file,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .codebtorDocumentsList[
                                                                                              sectionIndex
                                                                                            ]
                                                                                              .documents[
                                                                                              documentIndex
                                                                                            ],
                                                                                            "file",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "codebtorDocumentsList[sectionIndex].documents[documentIndex].file",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "b-icon",
                                                                                    {
                                                                                      class:
                                                                                        _vm.getClassIconDocument(
                                                                                          this,
                                                                                          _vm
                                                                                            .codebtorDocumentsList[
                                                                                            sectionIndex
                                                                                          ]
                                                                                            .documents[
                                                                                            documentIndex
                                                                                          ]
                                                                                        ),
                                                                                      attrs:
                                                                                        {
                                                                                          size: "is-medium",
                                                                                          icon: !_vm
                                                                                            .codebtorDocumentsList[
                                                                                            sectionIndex
                                                                                          ]
                                                                                            .documents[
                                                                                            documentIndex
                                                                                          ]
                                                                                            .file
                                                                                            ? _vm
                                                                                                .codebtorDocumentsList[
                                                                                                sectionIndex
                                                                                              ]
                                                                                                .documents[
                                                                                                documentIndex
                                                                                              ]
                                                                                                .uploaded
                                                                                              ? "check"
                                                                                              : "arrow-up-from-bracket"
                                                                                            : "paperclip",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    [
                                                                      [
                                                                        _vm
                                                                          .codebtorDocumentsList[
                                                                          sectionIndex
                                                                        ]
                                                                          .documents[
                                                                          documentIndex
                                                                        ]
                                                                          .uploaded ===
                                                                          true &&
                                                                        _vm.currentUser !==
                                                                          "PROSPECT"
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "document-icons my-2",
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.getProspectDocument(
                                                                                        _vm
                                                                                          .codebtorDocumentsList[
                                                                                          sectionIndex
                                                                                        ]
                                                                                          .documents[
                                                                                          documentIndex
                                                                                        ]
                                                                                          .documentId
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa-solid fa-file-lines",
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "access-to-document"
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                    ],
                                                                    2
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "column is-one-third" },
                      [
                        _c(
                          "div",
                          { staticClass: "card-item" },
                          [
                            _c(
                              "h3",
                              { staticClass: "title is-5 has-text-primary" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("uploaded-documents-section-title")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm._l(
                              _vm.documentsList,
                              function (
                                { description: sectionName },
                                sectionIndex
                              ) {
                                return _c("div", { key: sectionIndex }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "container-count-documents",
                                    },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          class: _vm.getClassColorText(
                                            _vm.counterUploadedDocuments(
                                              _vm.documentsList,
                                              sectionIndex
                                            ),
                                            _vm.counterDocuments(
                                              _vm.documentsList,
                                              sectionIndex
                                            )
                                          ),
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(sectionName) + ": "
                                          ),
                                        ]
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.counterUploadedDocuments(
                                              _vm.documentsList,
                                              sectionIndex
                                            )
                                          ) +
                                            "/" +
                                            _vm._s(
                                              _vm.counterDocuments(
                                                _vm.documentsList,
                                                sectionIndex
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              }
                            ),
                            _vm.hasCodebtor
                              ? _c(
                                  "div",
                                  _vm._l(
                                    _vm.codebtorDocumentsList,
                                    function (
                                      { description: sectionName },
                                      sectionIndex
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: sectionIndex,
                                          staticClass:
                                            "container-count-documents",
                                        },
                                        [
                                          _c(
                                            "h5",
                                            {
                                              class: _vm.getClassColorText(
                                                _vm.counterUploadedDocuments(
                                                  _vm.codebtorDocumentsList,
                                                  sectionIndex
                                                ),
                                                _vm.counterDocuments(
                                                  _vm.documentsList,
                                                  sectionIndex
                                                )
                                              ),
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(sectionName) + ": "
                                              ),
                                            ]
                                          ),
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.counterUploadedDocuments(
                                                  _vm.codebtorDocumentsList,
                                                  sectionIndex
                                                )
                                              ) +
                                                "/" +
                                                _vm._s(
                                                  _vm.counterDocuments(
                                                    _vm.codebtorDocumentsList,
                                                    sectionIndex
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            _c("div", [
                              !_vm.someFileIsNotEmpty
                                ? _c(
                                    "div",
                                    { staticClass: "has-text-centered mt-6" },
                                    [
                                      _c("img", {
                                        staticClass: "documents-icon",
                                        attrs: {
                                          src: require("@/ui/assets/img/documents.gif"),
                                          alt: "documents",
                                        },
                                      }),
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "title is-6 has-text-grey",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("no-document-message")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "btn-container" }, [
                                _c(
                                  "div",
                                  { staticClass: "has-text-centered mt-6" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "px-6 save-btn",
                                        attrs: {
                                          id: "save-btn",
                                          rounded: "",
                                          type: "is-success",
                                          loading: _vm.isLoading,
                                          disabled: !_vm.filesToSave,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.uploadedByRole === "PROSPECT"
                                              ? (_vm.saveFiles(),
                                                _vm.scrollToTop())
                                              : _vm.saveFiles()
                                          },
                                        },
                                      },
                                      [_vm._v(" Salvar documentos ")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.filesCompletedByAll() &&
                                _vm.buttonType.buttonName ===
                                  "buttonNamePreApproval" &&
                                _vm.approvalType.subStatus !==
                                  "DOCUMENTS_COMPLETED"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "has-text-centered mt-6",
                                        attrs: {
                                          id: "div-checkbox-accept-you",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("message-pré-aprovação")
                                            )
                                        ),
                                        _c("br"),
                                        _c(
                                          "b-checkbox",
                                          {
                                            staticClass:
                                              "mt-4 has-text-primary",
                                            model: {
                                              value: _vm.checkEnablePreApproval,
                                              callback: function ($$v) {
                                                _vm.checkEnablePreApproval = $$v
                                              },
                                              expression:
                                                "checkEnablePreApproval",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("you-accept")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "has-text-centered mt-4",
                                    attrs: { id: "div-button-to-approved" },
                                  },
                                  [
                                    _vm.filesCompletedByAll() &&
                                    _vm.approvalType.subStatus !==
                                      "DOCUMENTS_COMPLETED"
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "px-6 doc-btn",
                                            attrs: {
                                              id: "send-docs-btn",
                                              rounded: "",
                                              disabled:
                                                !_vm.checkEnablePreApproval ||
                                                !_vm.enableApprovalButton,
                                              type: "is-success",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.submitFiles(),
                                                  _vm.scrollToTop()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.buttonType.buttonName
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                        _c("credi-experto"),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hero-section" }, [
      _c("div", { staticClass: "curve-down" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }